export const SchoolInfoPlugin = store => {
    if (!store.getters.schoolInfo) {
        store.dispatch('getSchoolInfo')
    }
};


// WEBPACK FOOTER //
// ./src/store/plugins/school-info.plugin.js